import { render, staticRenderFns } from "./nav-create-institution.vue?vue&type=template&id=1d7183a2&"
import script from "./nav-create-institution.vue?vue&type=script&lang=js&"
export * from "./nav-create-institution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports